export function entityGenerator<R, O = R>(input: R): (overrides?: Partial<O>) => R
export function entityGenerator<R>(input: R): (overrides?: Partial<R>) => R {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (overrides?: any) => {
		return { ...input, ...overrides }
	}
}
